import { render, staticRenderFns } from "./CPPTTable.vue?vue&type=template&id=36c74442&scoped=true"
import script from "./CPPTTable.vue?vue&type=script&lang=js"
export * from "./CPPTTable.vue?vue&type=script&lang=js"
import style0 from "./CPPTTable.vue?vue&type=style&index=0&id=36c74442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c74442",
  null
  
)

export default component.exports